export default __webpack_public_path__ + "static/media/18.b2b7f23a.jpg";